<template>
    <div>
        <div class="modal fade bd-example-modal-lg" id="mdnotasfor" tabindex="-1" role="dialog"  aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
						<h5 class="modal-title" id="mdlinformacoesclientecliente"><i class="fa fa-info-circle"></i> Notas de entrada</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
                    <div class="modal-body" style="padding-bottom: 0px; padding-left: 0px; padding-right: 0px;">
                        <!-- Títulos em aberto -->
                        <div class="container-fluid">
                            <div class="row" v-if="totalnotas > 0">
                                <div class="col-lg-12">
                                    <div class="table-responsive">
                                        <table id="tblistanotasfor" class="table table-bordered table-sm table-hover">
                                            <thead class="thead-dark">
                                            <tr>
                                                 <th></th>
                                                 <th>Numero da Nota</th>
                                                 <th>Fornecedor</th>
                                                 <th>Data da entrada</th>
                                                 <th>Data da efetivação</th>
                                                 <th>Valor da nota</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(nota, index) in lstnotasfor">
                                                    
                                                    <tr  v-bind:key="index" style="font-size: 12px;" @click.prevent="mtdexpandiritens(index)">
                                                        <td class="text-center">
                                                            <span v-if="parseFloat(nota.conferidocolapse) === 0" style="font-size: 20px; cursor: pointer;" @click.prevent="mtdexpandiritens(index)"><i class="fa fa-chevron-circle-down text-primary"></i></span>
                                                            <span v-else style="font-size: 20px; cursor: pointer;"><i class="fa fa-chevron-circle-up text-primary" @click.prevent="mtdexpandiritens(index)"></i></span>													
                                                        </td> 
                                                        <td>{{ nota.numero }}</td>
                                                        <td>{{ nota.idfornecedor }} - {{ nota.nomefornecedor}}</td>
                                                        <td>{{ nota.dtentrada }}</td>
                                                        <td>{{ mtdformatadata(nota.dtefetivacao) }}</td>
                                                        <td>{{ mtdformatavalordecimal(parseFloat(nota.vtotvtotal), 2) }}</td>
                                                    </tr>
                                                    <tr v-bind:key="index"  style="font-size: 10px;">
                                                       <td colspan="6"  v-show="parseInt(nota.conferidocolapse) === 1"  style="padding-left: 35px; padding-right: 35px;">
                                                            <table id="tbclista" class="table table-bordered table-sm table-hover" style="margin-top: 2px; margin-bottom: 2px;">
                                                                <thead class="thead-light">
                                                                    <tr>
                                                                        <td>Código</td>
                                                                        <td>Descrição</td>
                                                                        <td>Und</td>
                                                                        <td>Marca</td>
                                                                        <td>Qtd</td>
                                                                        <td>Pr. compra</td>
                                                                        <td>Total</td>
                                                                    </tr>
                                                                </thead>


                                                                <tbody>
                                                                    <tr  v-for="(item, indexi) in nota.itens">
                                                                        <td>{{ item.idproduto }}</td>
                                                                        <td>{{ item.descricao }}</td>
                                                                        <td>{{ item.und }}</td>
                                                                        <td>{{ item.descmarca }}</td>
                                                                        <td>{{ item.qtditem }}</td>
                                                                        <td>{{  mtdformatavalordecimal(parseFloat(item.prcompra), 2) }}</td>
                                                                        <td>{{  mtdformatavalordecimal(parseFloat(item.vvtotal), 2) }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                       </td>
                                                    </tr>
                                                </template>    
                                            </tbody>                                        
                                        </table>
                                    </div>
                                </div>                                                                               
                            </div>
                            <div class="row" v-else>
                                <div class="col-12" style="display: flex; justify-content: center;">
                                    <big style="padding: 20px;"><i class="fa fa-search"></i> Nenhum registro encontrado para sua busca.</big>
                                </div>
                            </div>
                        </div>                 
					</div>
                    <div class="modal-footer" v-if="tpfiltro == 1">
                        <button type="button" class="btn btn-danger btn-sm" @click.prevent="mtdfechamdlnota()"> <i class="fa fa-reply"></i> Cancelar</button>
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdretornalistadeprodutos()"> Confirmar</button>
                    </div>
                </div>
            </div>
        </div>   
    </div>
</template>

<script>
 import util from '../utilitarios/util.js'
export default {
    name: 'cmpconsultanotasfor',
    components:{
    },    
    props:[    
        'idpedidocompra',
        'idfornecedor',
        'numeronota',
        'tpfiltro'
    ],
    data: function() {
        return {
            lstnotasfor: [],
            totalnotas: 0,
            lstprodutos : [],
        };
    },
    methods:{
        mtdexpandiritens(indice){
            if (parseInt(this.lstnotasfor[indice].conferidocolapse) === 1){
                this.lstnotasfor[indice].conferidocolapse = 0;
            }else{
                this.lstnotasfor[indice].conferidocolapse = 1;
            }
        },
        mtdformatadata(strdata){
            // Divide a string em duas partes usando o espaço como delimitador
            const partes = strdata.split(' ');
            
            // A primeira parte contém a data
            const data = partes[0];
            
            return data;
        },
        mtdformatavalordecimal(valor, digitos){
            return util.formatavalordecimais(valor, digitos);
        },  
        listarnotas(){
            var vself       = this;
            let loader      = this.$loading.show();
            let filtro = '';
            if(this.tpfiltro == 1){
                filtro      = ' and n.idfornecedor= '+ parseInt(this.idfornecedor) +' and n.numero='+parseInt(this.numeronota);
            }else{
                filtro      = ' and n.idfornecedor= '+ parseInt(this.idfornecedor) +' and n.codpedcompra='+parseInt(this.idpedidocompra);
            }

            let parametros  = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'listagem'},
                {parametro: 'filtro',       valor : filtro},
                {parametro: 'limit',        valor : '999999999'},
                {parametro: 'offset',       valor : '0'},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfornecedores.php');
            retorno.then(function (response) {
                vself.lstnotasfor   = response.data.notas;
                vself.lstprodutos   = response.data.notas[0].itens;
                vself.totalnotas    = response.data.totalnotas;
                loader.hide();
            }).catch(function (response) {
                vself.lstnotasfor = [];
                vself.totalnotas = 0;
                loader.hide();
            });
        },
        mtdfechamdlnota(){
            $('#mdnotasfor').modal('hide');
            $('#mdlexportanota').modal('show');
        },
        mtdretornalistadeprodutos(){
            let lstidprodutos = [];
            lstidprodutos = this.lstprodutos.map( produto => produto.idproduto)
            this.$emit('mtdretornalistadeprodutos', lstidprodutos);
        },
    },
    mounted() {
        let vself = this;
        $('#mdnotasfor').on('shown.bs.modal', function (e) {
            vself.lstnotasfor = [];
			vself.listarnotas();
        });   
    },
}
</script>

<style>

</style>